/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { sva } from "@panda/css";

export const newsCard = sva({
	slots: ["wrapper", "overlay", "image-box", "image", "meta"],
	base: {
		wrapper: {
			"&&": {
				display: "flex",
				gap: "eds.dimension.12",
				minHeight: "172px",
				flexGrow: "1",
				mdDown: {
					minHeight: "153px",
				},
			},

			"&:hover": {
				"& .image": {
					transform: "scale(1.05)",
				},
			},
			"& .cosmos-rich-text.heading": {
				lineClamp: "2",
				overflow: "hidden",
				mdDown: {
					lineClamp: "1",
				},
				"& p": {
					margin: 0,
				},
			},
			"& .cosmos-rich-text.paragraph": {
				lineClamp: "2",
				overflow: "hidden",
			},
			_chrome142: {
				backdropFilter: "none!",
			},
		},
		"image-box": {
			aspectRatio: "16/9",
			width: "263px",
			maxWidth: "263px",
			flexShrink: 0,
			flexGrow: 0,
			height: "auto",
			minH: "full",
			mdOnly: {
				aspectRatio: "1/1",
				width: "148px",
				maxWidth: "148px",
			},
			mdDown: {
				aspectRatio: "unset!important",
				width: "229px",
				maxWidth: "229px",
			},
			smDown: {
				width: "eds.dimension.96",
				maxWidth: "eds.dimension.96",
				minHeight: "eds.dimension.128",
			},
		},
		image: {
			transition: "transform token(animations.eds.duration.200) token(animations.eds.easing.easeInOutQuad)",
			height: "100%",
			width: "100%",
			objectFit: "cover",
		},
	},
});
